<template>
  <!-- The icon of a response option, in its own colour (US 9398). Give the option, or the task's options and the chosen title. -->
  <font-awesome-icon v-if="shown" :icon="shown.icon" :style="shown.style"/>
</template>

<script>
  import { iconForOption, responseIcon } from '@/views/Tasks/Assessment/responseIcon';

  export default {
    name: 'ResponseIcon',
    props: {
      option: {
        type: Object,
        default: null
      },
      options: {
        type: [String, Array],
        default: null
      },
      title: {
        type: String,
        default: null
      }
    },
    computed: {
      shown() {
        return this.option ? iconForOption(this.option) : responseIcon(this.options, this.title);
      }
    }
  }
</script>
